import { css } from '@/styled-system/css';

export const bannerCloseStyles = css.raw({
  flexShrink: '0',
  insetBlockStart: 'Banner.CloseButton.margin.top',
  insetInlineEnd: 'Banner.CloseButton.margin.right',
  marginBlockStart: `calc(-1 * {spacing.Banner.padding.vert})`,
  marginInlineEnd: `calc(-1 * {spacing.Banner.padding.horz})`,
});
